export function buttonActionFunc() {
  $('.tab').on('click', function () {
    $('.tab, .panel').removeClass('active');
    $(this).addClass('active');
    let index = $('.tab').index(this);
    $('.panel').eq(index).addClass('active');
  });

  $('.filtering button').on('click', function () {
    $(this).toggleClass('active').next('ul').slideToggle();
  });

  //スクロールを右端に設定 
  let table = $('.js-scrollable');
  $('#scrollRightBtn').click(function () {
    let maxScrollLeft = table.get(0).scrollWidth - table.width();
    $('.js-scrollable').animate({
      scrollLeft: maxScrollLeft
    }, 300);
  });
  $('#scrollLeftBtn').click(function () {
    let maxScrollLeft = table.get(0).scrollWidth - table.width();
    $('.js-scrollable').animate({
      scrollLeft: 0
    }, 300);
  });
}